// Provider allowlist parsing for position video embeds (plan C-7). Parsed
// with the real URL parser — never substring matching: require https, then an
// exact host match, then a charset-constrained video id in the path/params.
// Extra query params are ignored — real links carry them (Loom ?sid=…,
// YouTube &t=30s). Only the embed URL derived here is ever put in an iframe;
// the raw URL is never rendered as a link. The server performs the
// authoritative validation with the same rules.

const LOOM_PATH = /^\/(?:share|embed)\/([a-f0-9]{32})$/;
const YOUTUBE_ID = /^[A-Za-z0-9_-]{11}$/;
const YOUTUBE_EMBED_PATH = /^\/embed\/([A-Za-z0-9_-]{11})$/;
const YOUTUBE_SHORT_PATH = /^\/([A-Za-z0-9_-]{11})$/;

export function parseVideo(provider: "loom" | "youtube", rawUrl: string): { embedUrl: string } | null {
  let url: URL;
  try {
    url = new URL(rawUrl.trim());
  } catch {
    return null;
  }
  if (url.protocol !== "https:") {
    return null;
  }
  const host = url.host.toLowerCase();

  if (provider === "loom") {
    if (host !== "loom.com" && host !== "www.loom.com") {
      return null;
    }
    const match = LOOM_PATH.exec(url.pathname);
    if (match === null) {
      return null;
    }
    return { embedUrl: `https://www.loom.com/embed/${match[1]}` };
  }

  if (host === "youtube.com" || host === "www.youtube.com" || host === "m.youtube.com") {
    if (url.pathname === "/watch") {
      const id = url.searchParams.get("v") ?? "";
      if (!YOUTUBE_ID.test(id)) {
        return null;
      }
      return { embedUrl: `https://www.youtube.com/embed/${id}` };
    }
    const match = YOUTUBE_EMBED_PATH.exec(url.pathname);
    if (match === null) {
      return null;
    }
    return { embedUrl: `https://www.youtube.com/embed/${match[1]}` };
  }
  if (host === "youtu.be") {
    const match = YOUTUBE_SHORT_PATH.exec(url.pathname);
    if (match === null) {
      return null;
    }
    return { embedUrl: `https://www.youtube.com/embed/${match[1]}` };
  }
  return null;
}
